import fecha from 'fecha';
import _isEmpty from 'lodash/isEmpty'
import _isUndefined from 'lodash/isUndefined';
import fetch2 from '../../../fetch2';
import * as LandinConstansts from '../Shared/constants';
import { now, today } from '@mmt/legacy-commons/Helpers/dateHelpers';
import _isNull from 'lodash/isNull';
import { railsConfig } from "../../../RailsConfig";
import { getDefaultPostHeaders } from '../../NewListing/RailsListingActions';
import {_label} from "../../../vernacular/AppLanguage";
import {isOnlyEnglishCharacters} from "../../../vernacular/VernacularUtils";


export const getNonEmptyName = (originStation) => {
  if (_isEmpty(originStation.cityName)) {
    return _isEmpty(originStation.stationName) ? originStation.code : originStation.stationName;
  }
  return originStation.cityName;
}

export const getCityNameInEnglish = (station) => {
  const { engTranslate = '' } = station;
  if (_isEmpty(engTranslate) || _isNull(engTranslate) || engTranslate.length === 0) {
    return station.cityName;
  }
  const engTexts = engTranslate.split('###');
  if (engTexts.length > 1) {
    return engTexts[1].trim();
  }
  return station.cityName;
}

export const getDeeplinkFromSearchData = (searchData) => {
  const {
    originStation: { code: fromCode, cityName: fromCityName, stationName: fromStationName },
    destinationStation: { code: toCode, cityName: toCityName, stationName: toStationName },
    departureDate
  } = searchData;
  const date = fecha.format(departureDate, 'YYYYMMDD');
  return `mmyt://react/?page=railsListing&from_city=${encodeURIComponent(fromCityName)}&from=${fromCode}&from_station=${encodeURIComponent(fromStationName)}&to_city=${encodeURIComponent(toCityName)}&to=${toCode}&to_station=${encodeURIComponent(toStationName)}&departure=${date}`;
};

export const getCreateNewAccountRequest = (userAccount) => {
  const {
    userName,
    password,
    securityQuestion,
    securityAnswer,
    selectLanguage,
    enterFirstName,
    enterLastName,
    selectGender,
    enterEmail,
    enterMobileNumber,
    enterDob,
    selectOccupation,
    selectMaritalStatus,
    selectNationality,
    enterResidentialAddress,
    enterResidentialMobileNumber,
    enterPinCode,
    selectCity,
    selectState,
    selectPostOffice,
    country,
    enterOfficeAddress,
    enterOfficeMobileNumber,
    enterOfficePinCode,
    selectOfficeCity,
    selectOfficeState,
    selectOfficePostOffice,
    officeCountry,
    officeCheckBoxEnabled,
    enterCaptcha,
    status
  } = userAccount;
  let dateObject;

  try {
    dateObject = fecha.parse(enterDob.text, 'DD/MM/YYYY');
  } catch (e) {
    throw new Error('invalid date object');
  }
  const requiredDateFormat = fecha.format(dateObject, 'YYYYMMDD');
  if (officeCheckBoxEnabled) {
    return {
      userName: userName.text,
      passWord: password.text,
      cnfPassWord: password.text,
      securityQuestion: securityQuestion.id,
      securityAns: securityAnswer.text,
      prefLanguage: selectLanguage.id,
      firstName: enterFirstName.text,
      lastName: enterLastName.text,
      email: enterEmail.text,
      mobile: enterMobileNumber.text,
      dob: requiredDateFormat,
      occupation: selectOccupation.id,
      martialStatus: selectMaritalStatus.id,
      nationalityId: selectNationality.id,
      gender: selectGender.id,
      address: enterResidentialAddress.text,
      countryId: country.id,
      otherCountry: country.text,
      otherState: selectState.text,
      otherCity: selectCity.text,
      pinCode: enterPinCode.text,
      state: selectState.text,
      city: selectCity.text,
      postOffice: selectPostOffice.text,
      landlineNumber: enterResidentialMobileNumber.text,
      copyAddressResToOff: 'Y',
      off_Address: enterResidentialAddress.text,
      off_CountryId: country.id,
      off_otherCountry: country.id,
      off_otherState: selectState.text,
      off_otherCity: selectCity.text,
      off_PinCode: enterPinCode.text,
      off_State: selectState.text,
      off_City: selectCity.text,
      off_PostOffice: selectPostOffice.text,
      off_LandlineNumber: enterResidentialMobileNumber.text,
      area: selectCity.text,
      captcha:enterCaptcha.text,
      greq:status
    };
  }
  return {
    userName: userName.text,
    passWord: password.text,
    cnfPassWord: password.text,
    securityQuestion: securityQuestion.id,
    securityAns: securityAnswer.text,
    prefLanguage: selectLanguage.id,
    firstName: enterFirstName.text,
    lastName: enterLastName.text,
    email: enterEmail.text,
    mobile: enterMobileNumber.text,
    dob: requiredDateFormat,
    occupation: selectOccupation.id,
    martialStatus: selectMaritalStatus.id,
    nationalityId: selectNationality.id,
    gender: selectGender.id,
    address: enterResidentialAddress.text,
    countryId: country.id,
    otherCountry: country.text,
    otherState: selectState.text,
    otherCity: selectCity.text,
    pinCode: enterPinCode.text,
    state: selectState.text,
    city: selectCity.text,
    postOffice: selectPostOffice.text,
    landlineNumber: enterResidentialMobileNumber.text,
    copyAddressResToOff: 'N',
    off_Address: enterOfficeAddress.text,
    off_CountryId: officeCountry.id,
    off_otherCountry: officeCountry.text,
    off_otherState: selectOfficeState.text,
    off_otherCity: selectOfficeCity.text,
    off_PinCode: enterOfficePinCode.text,
    off_State: selectOfficeState.text,
    off_City: selectOfficeCity.text,
    off_PostOffice: selectOfficePostOffice.text,
    off_LandlineNumber: enterOfficeMobileNumber.text,
    area: selectCity.text,
    captcha:enterCaptcha.text,
    greq:status
  };
};

export const getRequestBody = (currentObject, value) => {
  if (currentObject.id === 'userName') {
    return {
      userid: value
    };
  } else if (currentObject.id === 'enterEmail') {
    return {
      email: value
    };
  } else if (currentObject.id === 'enterMobileNumber') {
    return { mobile: value };
  }
  throw new Error('wrong value input');
};

export const getAvailabilityStatus = (currentObject, response) => {
  if (currentObject.id === 'userName') {
    return !_isEmpty(response.useridAvailable) && response.useridAvailable === 'TRUE';
  }
  if (currentObject.id === 'enterEmail') {
    return !_isEmpty(response.emailAvailable) && response.emailAvailable === 'TRUE';
  }
  if (currentObject.id === 'enterMobileNumber') {
    return !_isEmpty(response.mobileAvailable) && response.mobileAvailable === 'TRUE';
  }
  return false;
};

const validateEnglishKeyboardIRCTC = (text) => {
    if(isOnlyEnglishCharacters(text)) {
      return {error : false, errorMessage : ""};
    } else {
      return {error : true, errorMessage : _label("type_in_english")};
    }
}
export const validate = async (selectedValue, currentObject) => {
  let {error, errorMessage} = validateEnglishKeyboardIRCTC(selectedValue);
  if(!error) {
    if (_isEmpty(selectedValue)) {
      error = true;
      errorMessage = currentObject.errorMessage.emptyErrorMessage;
    } else if (!_isUndefined(currentObject.onNextValidation)) {
      if (!currentObject.onNextValidation(selectedValue)) {
        error = true;
        errorMessage = currentObject.errorMessage.validationErrorMessage;
      }
    }
  }
  if (!error) {
    if (currentObject.id === 'userName' || currentObject.id === 'enterEmail' || currentObject.id === 'enterMobileNumber') {
      const requestBody = getRequestBody(currentObject, selectedValue);
      try {
        const res = await fetch2(railsConfig.userNameAvailability, {
          method: 'POST',
          headers: getDefaultPostHeaders(),
          body: JSON.stringify(requestBody)
        });

        if (!_isEmpty(res.status) && res.status !== 200) {
          throw new Error(_label("something_went_wrong"));
        }

        const response = await res.json();

        if (!_isEmpty(response.errorMessage)) {
          throw new Error(_label("something_went_wrong"));
        }

        const isAvailable = getAvailabilityStatus(currentObject, response);

        if (isAvailable) {
          error = false;
        } else {
          error = true;
          errorMessage = _label("username_already_registered",undefined, {userName : currentObject.headerText})
        }
      } catch (e) {
        error = false;
      }
    }
  }
  return {
    error,
    errorMessage
  };
};


export const isDepartureDatePassed = (departureDate) => {
  const date1 = fecha.parse(departureDate, 'DD-MM-YYYY');
  const date2Str = fecha.format(today(), 'DD-MM-YYYY');
  const date2 = fecha.parse(date2Str, 'DD-MM-YYYY');
  return date1 < date2;
};

export const isIrctcScheduledMaintainance = () => {
  const now = new Date();
  if (now.getHours() === 0) {
    now.setDate(now.getDate() + 1);
  }

  const start = new Date();
  start.setHours(LandinConstansts.IRCTC_MAINTAINANCE_START_TIME_HOURS, LandinConstansts.IRCTC_MAINTAINANCE_START_TIME_MINS, 0, 0);

  const end = new Date();
  end.setDate(end.getDate() + 1);
  end.setHours(LandinConstansts.IRCTC_MAINTAINANCE_END_TIME_HOURS, LandinConstansts.IRCTC_MAINTAINANCE_END_TIME_MINS, 0, 0);
  return false;
};

export const isSelectedTravelDateInRange = (selectedDate) => {
  const date = new Date();
  date.setDate(date.getDate() + LandinConstansts.IRCTC_BOOKING_DATE_LIMIT);
  return selectedDate <= date;
};
